"use strict";

App.Pages.Overview = class Overview extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true
			},
			path: '/overview',
			nameRu: 'Обзор',
		};
	}

	static get template()
	{
		//language=HTML
		return `
			<div class="page navbar-fixed">
				<div class="page-content ptr-content" pf="pageContent">

					<div class="page-header">
						<h3 pf="stellaName">Обзор</h3>
					</div>

					<div class="row resizable" pf="plots">
						<div class="col-30">
							<div class="card" style="padding: 16px;">
								<h4>В реальном времени</h4>
								<div pf="personCount" style="font-size: 46px; font-weight:bold;text-align: center;"></div>
								<div style="text-align: center; color: #8190AF; padding: 16px 16px 0px 16px;">Идентифицировано уникальных лиц в данный момент</div>
							</div>
							<div class="card" pf="topTenStell">
							</div>
							<div class="card" pf="topEmotions">
							</div>
						</div>	
						<div class="col-70">
							<div class="card" style="padding: 16px 16px 0 16px;">
								<h4 style="padding-left: 0;">Активность</h4>

								<div pf="item" style="display: flex; padding: 12px 0; color: #8190AF; font-size: 12px; ">
									<div style="width: 30%;"> Стела </div>				
									<div style="display: flex; width: 70%; padding-left: calc(5% + 40px);"> Соотношение детекций </div>							
								</div>
								
								<div pf="activStellas" style="border-top: 1px solid #E7EDF9; "> </div>
							</div>
							<div class="card" style="position: relative; padding: 0px;">
								<h4 style="padding: 16px;">Популярные районы</h4>
								
								<button style="position:absolute;z-index:10; top: 120px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomIn">
									<i class="material-icons" style="line-height:40px">zoom_in</i>
								</button>
								<button style="position:absolute;z-index:10; top: 180px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomOut">
									<i class="material-icons" style="line-height:40px">zoom_out</i>
								</button>
								<div pf="map" style="width: 100%; height: 40vh; overflow: hidden">
			
								</div>
			
							</div>
						</div>
					</div>

					</div>

					<div class="preloader-wrapper" pf="preloader" style="width: fit-content; margin: auto;">
						<div class="preloader" style="margin:40px auto; ">
							<span class="preloader-inner">
								<span class="preloader-inner-gap"></span>
								<span class="preloader-inner-left">
									<span class="preloader-inner-half-circle"></span>
								</span>
								<span class="preloader-inner-right">
									<span class="preloader-inner-half-circle"></span>
								</span>
							</span>
						</div>
					</div>

				</div>
			</div>

		`;
	}

	init()
	{
		super.init();
		this.loadStatus = true;
		this.errorStatus = false;

		this.bindDom({ preloader: 'show' }, 'loadStatus');
		this.bindDom({ plots: 'show' }, ['loadStatus', 'errorStatus'], (l, e) => !l && !e);

		this.dom.personCount.bindText();

		app.toast("Запрос данных...");
		app.request('/demo/plot/overview', [], (response) =>
		{
			app.toast("Ответ получен.");
			this.loadStatus = false;
			this.response = response;
			this.chekPoint = 0;
			if (this.response.status != 'FAIL')
			{
				this.errorStatus = false;
				// 
				this.creatChartsPie();
				//
				this.dom.personCount.text = Util.moneyFormat(this.response.data.calcPersons.response.all * 100);
				//
				this.list = new PF.Dom.List({
					dom: {
						element: this.dom.activStellas,
					},
					searchable: false,
					modelsConfig: {
						raw: this.response.data.topStellas.line
					},
					itemClass: Stella,

				});
				//

				ymaps.ready(() =>
				{
					this.map = new ymaps.Map(this.dom.map.node, {
						center: app.mapConfig.defaultCenter,
						zoom: 10, //app.mapConfig.defaultZoom,
						// ...app.mapConfig
						controls: ['fullscreenControl', 'typeSelector', 'geolocationControl', 'rulerControl'],
						// controls: []
					}, {
						maxZoom: 23
					});

					this.dom.zoomIn.on('click', () =>
					{
						this.map.setZoom(this.map.getZoom() + 1);
					});
					this.dom.zoomOut.on('click', () =>
					{
						this.map.setZoom(this.map.getZoom() - 1);
					});

					this.districtList = new PF.Map.PolygonList({
						sql: this.sql,
						map: this.map,
						square: 0,
						modelsConfig: {
							raw: this.response.data.topDistrict.response
						},
						itemClass: District,
					});

				}); //end ymaps
			}
			else
			{
				app.toast("Нет данных.");
				this.errorStatus = true;
			}
		}); //request
	} // init

	creatChartsPie()
	{
		let option = {
			chart: {
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				type: 'pie'
			},
			tooltip: {
				pointFormat: '<b>{point.percentage:.1f}%</b>'
			},
			accessibility: {
				point: {
					valueSuffix: '%'
				}
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						connectorWidth: 0,
						distance: 2,
						enabled: true,
						format: '{point.percentage:.1f} %'
					},
					showInLegend: true
				}
			}
		};

		this.emotions = new PF.Charts.Highcharts({
			dom: { element: this.dom.topEmotions },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4>Топ-5 эмоций</h4>`,
				align: 'left',
			},
			series: [this.response.data.topEmotions.series],
			...option
		});

		this.topStell = new PF.Charts.Highcharts({
			dom: { element: this.dom.topTenStell },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4>Топ-10 популярных мест</h4>`,
				align: 'left',
			},
			series: [this.response.data.topStellas.pie.series],
			...option
		});
	} // creatChartsPie

};


class District extends PF.Map.PolygonList.Item
{
	onRender()
	{
		let maxR = 2348.570973376865;
		let avgS = 17328351.5;
		// let r = (this.model.all / this.model.max) * maxR;
		// r=кор(s/p)
		let s = (this.model.all / this.model.max) * avgS;
		let r = Math.sqrt(s / Math.PI);

		this.myCircle = new ymaps.Circle(
			[[parseFloat(this.model.lat), parseFloat(this.model.lng)], r],
			{
				hintContent: `${this.model.name}<br>Детекций: ${this.model.all}`,
			},
			{
				// Опции.
				// Цвет заливки 
				fillColor: 'rgba(235,109,59,0.7)',
				// Цвет границ
				strokeColor: 'rgba(235,109,59,1)',

			});

		this.list.map.geoObjects.add(this.myCircle);

	} // onRender

}



class Stella extends PF.Dom.List.Item
{
	get renderer()
	{
		//language=HTML
		return `
			<li pf="item" style="display: flex; padding: 12px 0; border-bottom: 1px solid #E7EDF9; ">
              
				<div style="width: 30%;">@{model.name}</div>				
				<div style="display: flex; width: 70%;">
					<div style="padding: 0 16px; text-align: right; width: 5%;">@{model.y}</div>

					<div style="display: flex; width: 90%; align-items: center;">					
						<div style="height: 10px; background: #3773E3; width: ${((this.model.y * 100) / this.model.max) * 0.85}%;" ></div>
						
						<span  style="width: 10%; padding-left: 16px;">${Util.round(((this.model.y * 100) / this.model.summ), -2)}%</span>	
					</div>
				</div>							
			</li>
		`;
	}

	onRender()
	{
		super.onRender();
	}

}
